import { render, staticRenderFns } from "./logisticsInfo.vue?vue&type=template&id=b4069d8e&scoped=true&"
import script from "./logisticsInfo.vue?vue&type=script&lang=js&"
export * from "./logisticsInfo.vue?vue&type=script&lang=js&"
import style0 from "./logisticsInfo.vue?vue&type=style&index=0&id=b4069d8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4069d8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4069d8e')) {
      api.createRecord('b4069d8e', component.options)
    } else {
      api.reload('b4069d8e', component.options)
    }
    module.hot.accept("./logisticsInfo.vue?vue&type=template&id=b4069d8e&scoped=true&", function () {
      api.rerender('b4069d8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/module/logisticsInfo.vue"
export default component.exports